import './ui/styles/variables.css';
import './ui/styles/base.css';
import './ui/styles/grid.css';
import './ui/styles/controls.css';
import './ui/styles/modals.css';
import './ui/styles/toasts.css';
import './ui/styles/responsive.css';
import './ui/styles/accessibility.css';

import { App } from './app';

const app = new App();
app.start().catch((error) => {
  console.error('[Main] Failed to start application:', error);
  const appEl = document.getElementById('app');
  if (appEl) {
    appEl.innerHTML = `
      <div style="text-align:center;padding:2rem;">
        <h1>⚠️ Application Error</h1>
        <p>Failed to initialize. Please refresh the page.</p>
        <button onclick="location.reload()" style="padding:0.5rem 1rem;margin-top:1rem;">Reload</button>
      </div>
    `;
  }
});
